import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

interface Props {
    count: number;
    maxCount: number;
}

function CircleProgress({ count, maxCount }:Props) {
  const percent = (count / maxCount) * 100;
  return (
        <div className={styles.container}>
            <div className={styles.background}
            style={{
              background: percent === 0 ? 'var(--color-gray2)'
                : `conic-gradient(var(--color-primary) 0% ${percent}%, var(--color-gray2) ${percent}% 100%)`,
            }} />
            <div className={styles.contents}>
                <Row spacing={4}>
                    <Text color={colors.gray9}
                          size='2xl'
                          fontWeight='bold'>
                        {count}
                    </Text>
                    <Text size='lg'>/{maxCount}</Text>
                </Row>
            </div>
        </div>
  );
}

export default CircleProgress;
